import { Toaster } from '@ui'
import { get } from 'lodash'

export const handleGraphQLErrors = ({ graphQLErrors }: { graphQLErrors: any[] }) => {
  const altError = get(graphQLErrors[0], 'unknownErrors[0].message', '')
  const error = get(graphQLErrors[0], 'message', '')
  return Toaster.fail({
    message: `${error}\n${altError}`,
  })
}
